module.exports = __webpack_public_path__ + "static/move-606101c07fdd9c0cf98d4a5da60b7f40.png";